import { useNavigate } from "react-router-dom";
import BackButton from "../../components/BackButton";
import TitleRecordFunction from "../../components/TitleRecordFunction";
import { FaMagnifyingGlass } from "react-icons/fa6";
import { IoFlash } from "react-icons/io5";

const FlowMeasurementSearchChoice = () => {
    const navigate = useNavigate();

    return (
        <div className="flow-measurement-choice-container">
            <TitleRecordFunction
                addRecordMessage={""}
                deleteRecordMessage={""}
                title='Flow Measurement'
                isViewRecord={true}
            />
            <div className="flow-measurement-search-choice-card">
                <button
                    className='flow-measurement-search-choice-button'
                    onClick={() => navigate('/manage-database/flow-measurement/record')}
                >
                    Deep search <FaMagnifyingGlass />
                </button>
                <button
                    className='flow-measurement-search-choice-button'
                    onClick={() => navigate('/manage-database/flow-measurement/fast-record')}
                >
                    Fast search <IoFlash />
                </button>
            </div>
            <BackButton navigateTo='/manage-database'/>
        </div>
    )
}

export default FlowMeasurementSearchChoice;
